import { AccessLevelOption, AccessLevelTypes } from 'types/userRoles'

export const getInitialAccessLevelState = (
  accessLevelsOptions: AccessLevelOption[]
): {
  [key in AccessLevelTypes]: boolean
} => {
  return accessLevelsOptions.reduce((accumulator: any, level) => {
    return { ...accumulator, [level.value]: false }
  }, {})
}

export const getMappedData = (accessLevelsOptions: AccessLevelOption[], data: string[]) => {
  return accessLevelsOptions.reduce((accumulator, level) => {
    const hasAccess = data.includes(level.value)
    return { ...accumulator, [level.value]: hasAccess }
  }, getInitialAccessLevelState(accessLevelsOptions))
}

export const splitUserRoleType = (userRoleType: string) => {
  const sdhUserType = userRoleType?.split(' - ')?.[0] ?? ''
  const sdhUserRoleType = userRoleType?.split(' - ')?.[1] ?? ''
  return { sdhUserType, sdhUserRoleType }
}
